<template>
  <div>
    <EkomiSeal />
    <router-link
      :to="localizedRoute('/bester-online-shop.html#trustedshops')"
      class="badge-ts"
      v-if="storeCode == 'zaun24_de'"
    >
      <img
        v-lazy="'/assets/logo/logo-trustedshops.svg'"
        alt="Trusted Shops"
        width="70px"
        height="70px"
      >
    </router-link>
  </div>
</template>

<script>
import { storeCode as getStoreCode, localizedRoute } from '@vue-storefront/core/lib/multistore'
import EkomiSeal from '../Custom/EkomiSeal'

export default {
  name: 'FooterTrustSeals',
  components: {
    EkomiSeal
  },
  computed: {
    storeCode () {
      return getStoreCode()
    }
  }
}
</script>
